import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import errorImage from 'assets/img/whoops.png';

type Props = {
  error: Error;
  retry?: () => void;
};

/**
 * Smaller error component for in a Modal for example.
 *
 * @todo This is just the start. This component can use a lot of enhancements in the future
 * so it more flexible and can be used in more locations. Ideally we have just 1 error component instead of the 2 we have now.
 */
export function SmallError({ error, retry }: Props) {
  return (
    <StyledWrapperBox>
      <StyledErrorBox>
        <Typography variant="h2">Woops er ging iets mis.</Typography>
        <Typography variant="subtitle1">{error.name}</Typography>
        <Typography variant="caption">{error.message}</Typography>
        <StyledImage src={errorImage} alt="Error" />
        {retry && (
          <StyledButton variant="contained" onClick={retry}>
            <Typography variant="h3">Opnieuw</Typography>
          </StyledButton>
        )}
      </StyledErrorBox>
    </StyledWrapperBox>
  );
}

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.lwPrimaryAccentLight[100],
  borderRadius: theme.spacing(3),
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledErrorBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  padding: theme.spacing(2),
  margin: theme.spacing(2),
}));

const StyledImage = styled('img')(({ theme }) => ({
  height: '240px',
  width: '240px',
  alignSelf: 'center',
  margin: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
}));
